const RealEstateBanner = () => {
  return (
    <div className="bg-white max-w-[95%] mx-auto">
      {/* Large Text Full Width with Auto Adjust */}
      <div className="text-black font-bold text-left w-full leading-none"
        style={{
          fontSize: "clamp(40px, 50vw, 260px)", // Adjusts between 40px and 250px based on viewport size
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}
      >
        Fabulous
      </div>

      {/* Texts with a Horizontal Line */}
      <div className="flex items-start justify-between">
        <p className="text-gray-600 text-[16px]">Your housing needs deserve the care of a specialist, be home</p>
        <div className="w-[60%] h-[2px] bg-gray-400 mx-4 mt-3"></div>
        <p className="text-gray-600 text-[16px]">Let's go above and beyond to find your next home</p>
      </div>

      {/* Grid Layout */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
        {/* Left Box */}
        <div className="bg-orange-500 text-white p-6 rounded-2xl flex flex-col items-center justify-center">
          <button className="bg-white text-orange-500 px-4 py-2 rounded-lg font-semibold">
            Talk with us
          </button>
          <p className="mt-4">👨‍💼 Support Agent</p>
        </div>

        {/* Image */}
        <div className="relative">
          <img 
            src="https://i.pinimg.com/736x/11/54/3e/11543e73b3f6eb2a26088f9453ad2192.jpg"
            alt="Modern Home" className="rounded-2xl" 
          />
        </div>

        {/* Right Boxes */}
        <div className="space-y-6">
          <div className="bg-white p-6 rounded-2xl shadow-lg flex items-center">
            <span className="text-gray-900 font-semibold text-lg">Expect better</span>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-lg flex items-center">
            <span className="text-gray-900 font-semibold text-lg">Homes that match</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealEstateBanner;
